module.exports = __webpack_public_path__ + "static/media/panis_22.d694b76a.jpg";